import { useState, useEffect } from 'react';
import { D, st, apiGet, apiPost, apiDel } from '../constants';

export default function BetaRequests() {
  const [requests, setRequests] = useState([]);
  const [whitelist, setWhitelist] = useState([]);
  const [loading, setLoading] = useState(true);
  const [wInput, setWInput] = useState('');
  const [msg, setMsg] = useState('');

  const load = () => Promise.all([
    apiGet('/beta/requests').then(d=>setRequests(d.requests||[])),
    apiGet('/beta/whitelist').then(d=>setWhitelist(d.whitelist||[])),
  ]).finally(()=>setLoading(false));

  useEffect(()=>{ load(); },[]);

  const approve = async id => { try { await apiPost('/beta/approve/'+id,{}); setMsg('Approved and invite sent.'); load(); } catch(e){ setMsg('Error: '+e.error); } };
  const deny = async id => { try { await apiPost('/beta/deny/'+id,{}); setMsg('Denied.'); load(); } catch(e){ setMsg('Error: '+e.error); } };
  const deleteRequest = async id => { if (!confirm('Delete this request?')) return; try { await apiDel('/beta/requests/'+id); setMsg('Deleted.'); load(); } catch(e){ setMsg('Error: '+(e.error||e.message)); } };
  const resendInvite = async id => { try { await apiPost('/beta/resend/'+id,{}); setMsg('Invite resent.'); } catch(e){ setMsg('Error: '+(e.error||e.message)); } };
  const addWhitelist = async () => {
    if (!wInput.trim()) return;
    try { await apiPost('/beta/whitelist',{email:wInput.trim()}); setWInput(''); setMsg('Added to whitelist.'); load(); }
    catch(e){ setMsg('Error: '+(e.error||e.message)); }
  };
  const removeWhitelist = async email => {
    try { await apiDel('/beta/whitelist/'+encodeURIComponent(email)); setMsg('Removed from whitelist.'); load(); }
    catch(e){ setMsg('Error: '+(e.error||e.message)); }
  };

  const th = { padding:'10px 14px', textAlign:'left', fontSize:12, color:D.muted, fontWeight:600, borderBottom:'1px solid '+D.border, whiteSpace:'nowrap' };
  const td = { padding:'10px 14px', fontSize:13, borderBottom:'1px solid '+D.border, verticalAlign:'middle' };
  const green = '#22c55e';
  const statusColor = s => s==='approved'?green:s==='denied'?D.danger:D.muted;

  if (loading) return <div style={{padding:40,color:D.muted}}>Loading...</div>;

  return (
    <div style={{padding:'24px 28px',maxWidth:1100}}>
      <div style={{fontWeight:800,fontSize:22,marginBottom:20}}>Beta Requests</div>
      {msg && <div style={{background:green+'22',border:'1px solid '+green,borderRadius:8,padding:'10px 16px',marginBottom:16,fontSize:13,color:green,cursor:'pointer'}} onClick={()=>setMsg('')}>{msg}</div>}

      <div style={{background:D.card,borderRadius:12,border:'1px solid '+D.border,overflow:'hidden',marginBottom:32}}>
        <div style={{overflowX:'auto'}}>
          <table style={{width:'100%',borderCollapse:'collapse'}}>
            <thead><tr>
              <th style={th}>Name</th><th style={th}>Email</th><th style={th}>Company</th>
              <th style={th}>Size</th><th style={th}>Location</th><th style={th}>Years</th>
              <th style={th}>Submitted</th><th style={th}>Status</th><th style={th}>Actions</th>
            </tr></thead>
            <tbody>
              {requests.length===0 && <tr><td colSpan={9} style={{...td,color:D.muted,textAlign:'center',padding:28}}>No requests yet.</td></tr>}
              {requests.map(r=>(
                <tr key={r.id}>
                  <td style={td}>{r.name}</td>
                  <td style={td}>{r.email}</td>
                  <td style={td}>{r.company}</td>
                  <td style={td}>{r.size}</td>
                  <td style={td}>{r.location}</td>
                  <td style={td}>{r.years}</td>
                  <td style={td}>{r.submitted_at?new Date(r.submitted_at).toLocaleDateString():'-'}</td>
                  <td style={td}><span style={{color:statusColor(r.status),fontWeight:600,fontSize:12,textTransform:'capitalize'}}>{r.status}</span></td>
                  <td style={td}>
                    {r.status==='pending'&&<>
                      <button onClick={()=>approve(r.id)} style={{...st.btn('primary'),marginLeft:0,padding:'4px 12px',fontSize:12,marginRight:6}}>Approve</button>
                      <button onClick={()=>deny(r.id)} style={{background:'none',border:'1px solid '+D.danger,borderRadius:6,color:D.danger,fontSize:12,padding:'4px 10px',cursor:'pointer'}}>Deny</button>
                    </>}
                    {r.status!=='pending'&&<span style={{color:D.muted,fontSize:12,textTransform:'capitalize'}}>{r.status}</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div style={{fontWeight:700,fontSize:17,marginBottom:14}}>Whitelist</div>
      <div style={{display:'flex',gap:10,marginBottom:16}}>
        <input value={wInput} onChange={e=>setWInput(e.target.value)} onKeyDown={e=>e.key==='Enter'&&addWhitelist()} placeholder='Add email to whitelist...' style={{flex:1,padding:'10px 14px',borderRadius:8,border:'1px solid '+D.border,background:D.bg,color:D.text,fontSize:14,outline:'none'}}/>
        <button onClick={addWhitelist} style={{...st.btn('primary'),marginLeft:0,padding:'10px 20px'}}>Add</button>
      </div>
      <div style={{background:D.card,borderRadius:12,border:'1px solid '+D.border,overflow:'hidden'}}>
        {whitelist.length===0&&<div style={{padding:24,color:D.muted,fontSize:13,textAlign:'center'}}>No emails on whitelist yet.</div>}
        {whitelist.map(w=>(
          <div key={w.email} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'12px 16px',borderBottom:'1px solid '+D.border}}>
            <div>
              <div style={{fontSize:13,fontWeight:500}}>{w.email}</div>
              <div style={{fontSize:11,color:D.muted,marginTop:2}}>Added {w.added_at?new Date(w.added_at).toLocaleDateString():'-'}</div>
            </div>
            <button onClick={()=>removeWhitelist(w.email)} style={{background:'none',border:'1px solid '+D.danger,borderRadius:6,color:D.danger,fontSize:12,padding:'4px 10px',cursor:'pointer'}}>Remove</button>
          </div>
        ))}
      </div>
    </div>
  );
}
